export const GRE_ARTICLE_ACCESS_FORBIDDEN_DETAIL =
  'Article not assigned to authenticated user';

export const GRE_ARTICLE_ACCESS_REDIRECT_PATH = '/exams/gre/verbal/vocabulary';

export const createGreArticleAccessForbiddenError = ({
  resourceLabel = 'article',
} = {}) => {
  const error = new Error(GRE_ARTICLE_ACCESS_FORBIDDEN_DETAIL);
  error.code = 'GRE_ARTICLE_ACCESS_FORBIDDEN';
  error.status = 403;
  error.detail = GRE_ARTICLE_ACCESS_FORBIDDEN_DETAIL;
  error.resourceLabel = resourceLabel;
  return error;
};

export const isGreArticleAccessForbiddenError = (error) =>
  error?.code === 'GRE_ARTICLE_ACCESS_FORBIDDEN' ||
  (error?.status === 403 &&
    error?.detail === GRE_ARTICLE_ACCESS_FORBIDDEN_DETAIL) ||
  error?.message === GRE_ARTICLE_ACCESS_FORBIDDEN_DETAIL;

export const buildGreArticleAccessBlockedMessage = ({
  resourceLabel = 'article',
} = {}) =>
  `This ${resourceLabel} is not part of your assigned GRE vocabulary library yet. Redirecting you to your vocabulary articles.`;
